import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4f4265d2"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "header space"
  }, " 考勤记录 ", -1);
});

var _hoisted_2 = {
  class: "record"
};
var _hoisted_3 = ["onClick"];

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "header space"
  }, " 会议心得 ", -1);
});

var _hoisted_5 = {
  key: 0,
  class: "tipsdetail"
};
var _hoisted_6 = {
  key: 1
};

var _hoisted_7 = /*#__PURE__*/_createTextVNode(" 填写心得 ");

var _hoisted_8 = {
  key: 1,
  style: {
    "margin-top": "20px"
  }
};

var _hoisted_9 = /*#__PURE__*/_createTextVNode(" 确定 ");

var _hoisted_10 = /*#__PURE__*/_createTextVNode(" 取消 ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");

  var _component_el_col = _resolveComponent("el-col");

  var _component_el_row = _resolveComponent("el-row");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_input = _resolveComponent("el-input");

  var _component_TrainDetail = _resolveComponent("TrainDetail");

  var _directive_debounce = _resolveDirective("debounce");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Head, {
    title: "党校培训",
    back: true
  }), _ctx.showDetail ? (_openBlock(), _createBlock(_component_TrainDetail, {
    key: 0,
    detail: _ctx.detail,
    "show-attachment": _ctx.showAttachment,
    onDownFile: _ctx.downFile
  }, {
    other: _withCtx(function () {
      return [_ctx.detail.attendance == 1 ? (_openBlock(), _createBlock(_component_el_row, {
        key: 0,
        class: "more"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(function () {
              return [_hoisted_1, _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recoder, function (item, index) {
                return _openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "li"
                }, [_createElementVNode("div", null, _toDisplayString(item.title) + "：" + _toDisplayString(_ctx.attentionPerson[item.num]) + "人", 1), _createElementVNode("div", {
                  class: "watch",
                  onClick: function onClick($event) {
                    return _ctx.toWatch(item.title);
                  }
                }, " 查看 ", 8, _hoisted_3)]);
              }), 128))])];
            }),
            _: 1
          })];
        }),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_row, {
        class: "more"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(function () {
              return [_hoisted_4, _ctx.attentDetail.tips ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.attentDetail.tips), 1)) : _createCommentVNode("", true), _ctx.detail.status == 5 && _ctx.attentDetail.punch == 1 && _ctx.attentDetail.tips == '' || _ctx.takingLeave == 3 || _ctx.detail.status == 5 && _ctx.attentDetail.tips == '' && _ctx.attentDetail.punch == 7 || _ctx.detail.status == 5 && _ctx.attentDetail.tips == '' && _ctx.attentDetail.punch == 3 || _ctx.detail.status == 5 && _ctx.detail.attendance == 2 && _ctx.attentDetail.tips == '' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [!_ctx.write ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                size: "medium",
                class: "btnSign",
                onClick: _cache[0] || (_cache[0] = function ($event) {
                  return _ctx.write = true;
                })
              }, {
                default: _withCtx(function () {
                  return [_hoisted_7];
                }),
                _: 1
              })) : _createCommentVNode("", true), _ctx.write ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_el_input, {
                modelValue: _ctx.experience.tips,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return _ctx.experience.tips = $event;
                }),
                rows: 3,
                type: "textarea",
                placeholder: "输入心得体会 （10~500字之间）"
              }, null, 8, ["modelValue"]), _createElementVNode("div", null, [_withDirectives(_createVNode(_component_el_button, {
                size: "medium",
                class: "btnSign",
                onClick: _ctx.submit
              }, {
                default: _withCtx(function () {
                  return [_hoisted_9];
                }),
                _: 1
              }, 8, ["onClick"]), [[_directive_debounce]]), _createVNode(_component_el_button, {
                size: "medium",
                class: "btnSign gray",
                onClick: _cache[2] || (_cache[2] = function ($event) {
                  return _ctx.write = false;
                })
              }, {
                default: _withCtx(function () {
                  return [_hoisted_10];
                }),
                _: 1
              })])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["detail", "show-attachment", "onDownFile"])) : _createCommentVNode("", true)], 64);
}